module.exports = __webpack_public_path__ + "static/media/Intersection 29.007f3e88.png";